var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCircleWaitingFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18Zm2.845-13.379-.144.573a3.404 3.404 0 0 1-.766 1.414C10.343 7.28 9.5 8.351 9.5 9c0 .65.843 1.72 1.435 2.392.36.408.635.887.766 1.414l.144.573a.5.5 0 0 1-.485.621H6.64a.5.5 0 0 1-.485-.621l.143-.573a3.405 3.405 0 0 1 .767-1.414C7.657 10.72 8.5 9.649 8.5 9c0-.65-.843-1.72-1.435-2.392a3.405 3.405 0 0 1-.767-1.414l-.143-.573A.5.5 0 0 1 6.64 4h4.72a.5.5 0 0 1 .485.621Z",
  clipRule: "evenodd"
})));
export default SvgIconCircleWaitingFilled;